import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import CategoryWiseIncidents from './CategoryWiseIncidents';
import CategoryWiseIncidentsModal from './CategoryWiseIncidentsModal';
const DateWiseIncidents = ({ data, incident_details }) => {
  const [state, setState] = React.useState(null);
  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
    category: '',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );
  const [modalData, setModalData] = useState([]);
  const targetRef = useRef(null);
  useEffect(() => {
    setState({
      series: [
        {
          name: 'Incidents',
          data: data?.data,
        },
      ],

      options: {
        chart: {
          type: 'area',
          height: 350,
          zoom: {
            enabled: false,
          },
          events: {
            click: (event, chartContext, config) => {
              const selectedCategory = data?.categories[config.dataPointIndex];
              const selectedValue = data?.data[config.dataPointIndex];
              const incidents = incident_details
                .flat() // Flatten the array in case it's nested
                .filter((incident) => {
                  return (
                    moment(incident.date).format('DD/MM/YYYY') ===
                    moment(selectedCategory).format('DD/MM/YYYY')
                  );
                });
              if (incidents.length > 0) {
                setModalData(incidents); // Save as an array of objects
                setShowIncidentDetailsModal((prev) => ({
                  ...prev,
                  show: true,
                  category: moment(selectedCategory).format('DD/MM/YYYY'),
                }));
              }
            },
          },
          toolbar: {
            show: false, // Disable the toolbar
            tools: {
              download: false, // Disable the download option
            },
          },
        },
        legend: {
          show: false, // Turn off the legend
        },

        colors: ['#ED1D24'],
        dataLabels: {
          enabled: true,
        },
        labels: data?.categories,
        xaxis: {
          // type: 'datetime',
          labels: {
            formatter: function (value) {
              // Use moment to format the date in DD/MM
              return moment(value).format('DD/MM');
            },
          },
        },
        yaxis: {
          opposite: true,
          labels: {
            show: false,
          },
        },
      },
    });
  }, [data]);
  return (
    <>
      {state && (
        <ReactApexChart
          options={state.options}
          series={state.series}
          type='area'
          height={200}
        />
      )}
      {showIncidentDetailsModal.show && (
        <CategoryWiseIncidentsModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
        />
      )}
    </>
  );
};
export default DateWiseIncidents;
